module.exports = __webpack_public_path__ + "img/home-serve1.89c2147f.png";